import Icon from '../Icon.vue'

Icon.register({
  'close': {
    width: 16,
    height: 16,
    paths: [
      {
        d: 'M14.996.293a1 1 0 00-1.415 0L7.644 6.23 1.707.293A1 1 0 00.293 1.707L6.23 7.644.651 13.223a1 1 0 001.415 1.414l5.578-5.579 5.579 5.58a1 1 0 001.414-1.415L9.058 7.644l5.938-5.937a1 1 0 000-1.414z'
      }
    ]
  }
})
